export const galleryItems = [
  {
    id: 1,
    title: "ワンカラー（ローズ）",
    category: "ワンカラー",
    image: "https://public.readdy.ai/ai/img_res/9cf502d50154af6009035d032ac9d327.jpg",
    aspect: "portrait"
  },
  {
    id: 2,
    title: "フレンチ×ストーン",
    category: "フレンチ",
    image: "https://readdy.ai/api/search-image?query=classic%20French%20manicure%20with%20crystal%20stone%20details%2C%20elegant%20and%20luxurious%20nail%20art%2C%20gold%20and%20white%20accents%2C%20high-end%20nail%20salon%20photography%2C%20soft%20cream%20background%2C%20sophisticated%20feminine%20nail%20design&width=600&height=400&seq=gal2&orientation=landscape"
  },
  {
    id: 3,
    title: "グラデーション（ピンク）",
    category: "グラデーション",
    image: "https://readdy.ai/api/search-image?query=soft%20pink%20gradient%20ombre%20nail%20manicure%2C%20blush%20to%20white%20fade%2C%20elegant%20feminine%20style%2C%20gel%20nails%2C%20luxury%20nail%20salon%20photography%2C%20cream%20white%20background%2C%20sophisticated%20nail%20art%20design&width=600&height=400&seq=gal3&orientation=landscape"
  },
  {
    id: 4,
    title: "フラワーアート",
    category: "アート",
    image: "https://readdy.ai/api/search-image?query=delicate%20floral%20nail%20art%20design%2C%20tiny%20hand-painted%20flowers%2C%20soft%20pink%20and%20white%20petals%2C%20elegant%20and%20feminine%2C%20luxury%20nail%20salon%20photography%2C%20light%20background%2C%20sophisticated%20detailed%20nail%20art&width=600&height=400&seq=gal4&orientation=landscape"
  },
  {
    id: 5,
    title: "大人ベージュ",
    category: "ワンカラー",
    image: "https://readdy.ai/api/search-image?query=sophisticated%20nude%20beige%20nail%20manicure%2C%20mature%20elegant%20style%2C%20perfect%20gel%20finish%2C%20natural%20skin%20tone%20nail%20color%2C%20luxury%20nail%20salon%20photography%2C%20minimalist%20background%2C%20refined%20and%20understated%20beauty&width=600&height=400&seq=gal5&orientation=landscape"
  },
  {
    id: 6,
    title: "ミラーグラデーション",
    category: "グラデーション",
    image: "https://readdy.ai/api/search-image?query=mirror%20chrome%20gradient%20nail%20art%2C%20rose%20gold%20metallic%20effect%2C%20luxury%20nail%20design%2C%20elegant%20and%20glamorous%2C%20high-end%20nail%20salon%20photography%2C%20white%20background%2C%20sophisticated%20nail%20manicure&width=600&height=400&seq=gal6&orientation=landscape"
  },
  {
    id: 7,
    title: "和モダン（桜）",
    category: "アート",
    image: "https://readdy.ai/api/search-image?query=Japanese%20cherry%20blossom%20sakura%20nail%20art%2C%20delicate%20pink%20petals%2C%20elegant%20Japanese%20modern%20style%2C%20luxury%20nail%20design%2C%20soft%20pink%20and%20white%20colors%2C%20nail%20salon%20photography%2C%20sophisticated%20feminine%20aesthetic&width=600&height=400&seq=gal7&orientation=landscape"
  },
  {
    id: 8,
    title: "スクエアフレンチ",
    category: "フレンチ",
    image: "https://readdy.ai/api/search-image?query=square%20French%20tip%20nail%20manicure%2C%20modern%20angular%20French%20nail%20design%2C%20clean%20white%20tip%20on%20soft%20pink%20base%2C%20luxury%20nail%20salon%20photography%2C%20elegant%20and%20chic%20style%2C%20cream%20background&width=600&height=400&seq=gal8&orientation=landscape"
  },
  {
    id: 9,
    title: "3Dフラワー",
    category: "アート",
    image: "https://readdy.ai/api/search-image?query=3D%20flower%20gel%20nail%20art%2C%20dimensional%20sculpted%20floral%20design%2C%20white%20and%20pink%20flowers%2C%20luxury%20nail%20salon%20photography%2C%20elegant%20and%20sophisticated%20nail%20design%2C%20light%20background%2C%20feminine%20high-end%20nail%20art&width=600&height=800&seq=gal9&orientation=portrait",
    aspect: "portrait"
  }
];

export const galleryCategories = ["すべて", "ワンカラー", "フレンチ", "グラデーション", "アート"];
